import { Trans } from "react-i18next";
import { BoardItemHistory } from "../../../models";
import locale from "../../../constants/locale";
import { useStore } from "../../../stores";

const Histories = ({
  boardColumns,
  histories,
}: {
  boardColumns: any;
  histories?: BoardItemHistory[];
}) => {
  const { users } = useStore("users");
  const { boardMode } = useStore("boards");
  if (!histories?.length) {
    return null;
  }

  return (
    <ul>
      {histories?.map((f, i) => {
        const user = users?.find((u) => u.id === f?.createdBy);
        return (
          <li key={i}>
            {boardMode === "pipeline" ? (
              <span>
                Move to <b>{boardColumns[f.currentStageId]}</b> at{" "}
                <b>{f.addedAt.toFormat("M/d/yyyy, h:mm a")}</b>
                {f.removedAt ? (
                  <>
                    {" "}
                    and removed at{" "}
                    <b>{f.removedAt.toFormat("M/d/yyyy, h:mm a")}</b>
                  </>
                ) : (
                  ""
                )}
              </span>
            ) : (
              <Trans
                parent="span"
                className="is-flex"
                style={{
                  gap: 4,
                }}
                i18nKey={
                  i === 0
                    ? locale.ticketHistoryAdded
                    : locale.ticketHistoryMoved
                }
                values={{
                  user: user?.name ?? "User",
                  previousStage: boardColumns[f?.previousStageId!] ?? "Unknown",
                  currentStage: boardColumns[f.currentStageId],
                  time: f.addedAt.toFormat("M/d/yyyy, h:mm a"),
                }}
                components={[<b />, <b />, <b />, <b />]}
              />
            )}
          </li>
        );
      })}
    </ul>
  );
};

export default Histories;
